import { combineReducers } from 'redux';

import {
  RECEIVE_NAVI,
  RECEIVE_PAGES,
  RECEIVE_DATE,
  SWITCH_LANG,
  RECEIVE_FRONTPAGE,
  RECEIVE_INSTAGRAM,
  RECEIVE_CONTACT,
  RECEIVE_BLOGS,
  RECEIVE_PRESS,
  RECEIVE_MEDIA,
  RECEIVE_COLLECTIONS,
  RECEIVE_BWINMEDIA,
  RECEIVE_JOBS,
  RECEIVE_JOB_CONTAINERS
} from './actions';

function storeState(key, state) {
  localStorage.setItem(`bw_restaurants_${key}`, JSON.stringify(state));
};

function getStoredState(key) {
  return JSON.parse(localStorage.getItem(`bw_restaurants_${key}`));
};

function navi(state = null, action) {
  if (action.type === RECEIVE_NAVI) {
    return action.items;
  }

  return state;
}

function pages(state = {}, action) {
  if (action.type === RECEIVE_PAGES) {
    const items = Object.assign({}, state, {
      [action.item.slug]: action.item
    });

    return items;
  }

  return state;
}

function date(state = new Date(), action) {
  if (action.type === RECEIVE_DATE) {
    return new Date(action.date);
  }

  return state;
}

// the language of page
const lang = (state = getStoredState('lang') || "fi", action) => {
  switch (action.type) {
    case SWITCH_LANG:
      const lang = state === "fi" ? "en" : "fi";
      storeState('lang', lang);
      return lang;
    default:
      return state;
  }
}

// the frontpage
const front = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_FRONTPAGE:
      return action.data;
    default:
      return state;
  }
}

// the instagrams
const instagrams = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_INSTAGRAM:
      return action.data;
    default:
      return state;
  }
}

// contact page
const contact = (state={},action) => {
  switch(action.type)
  {
    case RECEIVE_CONTACT:
      return action.data;
    default:
      return state;
  }
}

// blogs page
const blogs = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_BLOGS:
      return action.data;
    default:
      return state;
  }
}

// press release page
const press = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_PRESS:
      return action.data;
    default:
      return state;
  }
}

// press release page
const media = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_MEDIA:
      return action.data;
    default:
      return state;
  }
}

// collections
const collections = (state=null,action) => {
  switch (action.type) {
    case RECEIVE_COLLECTIONS:
      return action.collection;
    default:
      return state;
  }
}

// bw in media page
const bwinmedia = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_BWINMEDIA:
      return action.data;
    default:
      return state;
  }
}

// jobs
const jobs = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_JOBS:
      return action.data;
    default:
      return state;
  }
}

// job containers
const jobContainers = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_JOB_CONTAINERS:
      return action.data;
    default:
      return state;
  }
}

export default combineReducers({
  navi,
  pages,
  date,
  lang,
  front,
  instagrams,
  contact,
  blogs,
  press,
  media,
  collections,
  bwinmedia,
  jobs,
  jobContainers
})



// WEBPACK FOOTER //
// ./src/redux/reducers.js